import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchFaqsFromMerchantAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const FetchFaqsFromMerchant = createAsyncThunk('get/fetchFaqsFromMerchant', FetchFaqsFromMerchantAPI);

export const FetchFaqsFromMerchantSlice = createSlice({
	name: 'fetchFaqsFromMerchant',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[FetchFaqsFromMerchant.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[FetchFaqsFromMerchant.rejected.toString()]: setAPIError,
		[FetchFaqsFromMerchant.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload, meta } = action;
			const module = (meta as any)?.arg?.module ?? 'PAYMENT_SWIPE';
			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = {
				[module]: payload?.data.filter((val: any) => val.id === module),
			};
			//console.log('============paylstate.dataoad', state.data);
		},
	},
});

interface IStates {
	[FetchFaqsFromMerchantSlice.name]: ReturnType<typeof FetchFaqsFromMerchantSlice.reducer>;
}

export const fetchFaqsFromMerchantSelector = (state: IStates): any => {
	return state[FetchFaqsFromMerchantSlice.name] || {};
};

export const useFetchFaqsFromMerchant = (): any => useSelector(fetchFaqsFromMerchantSelector);

export const fetchFaqsFromMerchant =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchFaqsFromMerchant(params));
		return;
	};

export const resetFetchFaqsFromMerchant =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchFaqsFromMerchantSlice.actions.RESET());
		return;
	};
